/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import "./Payment.css"; // Importing the CSS file

const Payment = () => {
  return (
    
    <div className="payment-container">
      <h1>Payment Options</h1>
      <p>Pay Your Invoice with Ease</p>

      <div className="payment-methods">
        <h2>Payment Methods</h2>

        <div className="method">
          <h3>1. Wire Transfer (International SWIFT)</h3>
          <p>
            Send payments directly to Copart’s bank account via wire transfer. 
            Ensure you follow the wire transfer instructions provided on your invoice.
          </p>
        </div>

        <div className="method">
          <h3>2. Debit Card</h3>
          <p>
            Use your debit card for deposits or small partial payments. 
            For full vehicle purchases, please use an alternative payment method. 
            <strong>Note:</strong> We accept all major debit cards.
          </p>
        </div>

        <div className="method">
          <h3>3. Local Funds Payment</h3>
          <p>
            Depending on your country of purchase, we may accept payments in your local currency. 
            Speak with our Customer Support team to explore your available options.
          </p>
        </div>
      </div>

      <div className="payment-instructions">
        <h2>How to Make a Payment</h2>
        <ul>
          <li>1. Log into your account and navigate to your invoice.</li>
          <li>2. Select your preferred payment method.</li>
          <li>3. Complete the payment according to the instructions on your invoice.</li>
          <li>4. Once processed, we will confirm your payment and update your account.</li>
        </ul>
        <p><strong>PS:</strong> We recommend speaking with our Customer Support team to determine the best payment method for you.</p>
      </div>

      <div className="payment-deadlines">
        <h2>Payment Deadlines</h2>
        <p>Payments for vehicles are <strong>due within 3 business days</strong> (including the day of sale) from the auction’s close.</p>
        <p>Late payments incur a <strong>late payment fee</strong>, which may vary depending on the auction lot.</p>
        <p><strong>Storage fees</strong> are applied daily and cannot be waived.</p>
        <p>If payment is not received <strong>within 7 days</strong>, the vehicle will be relisted, and your deposit will be forfeited to cover penalties and applicable charges.</p>
      </div>

      <div className="support">
        <h2>Need Help?</h2>
        <p>Our Customer Support team is available to assist you with payment inquiries.</p>
        <a href="#">Visit our Support Center</a>
      </div>
    </div>
  );
};

export default Payment;
